import { render, staticRenderFns } from "./PhotographyWhatNoToDoSection.vue?vue&type=template&id=33e2c91e"
import script from "./PhotographyWhatNoToDoSection.vue?vue&type=script&lang=ts"
export * from "./PhotographyWhatNoToDoSection.vue?vue&type=script&lang=ts"
import style0 from "./PhotographyWhatNoToDoSection.vue?vue&type=style&index=0&id=33e2c91e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports